import { Answers, QuestionCodes } from "../../../UserJourney/UserJourneyMap";
import CoreUtils from "../../../core/coreUtils";

// Reference for score calculations:
// <https://www.hiv.uw.edu/page/mental-health-screening/phq-2>

const AnswerScoreMap = Object.values(Answers.GadPhq).map((answer, index) => {
    return {
        answer: answer,
        score: index
    };
});

const ScoreMap = {
    [QuestionCodes.gadNervous]: AnswerScoreMap,
    [QuestionCodes.gadWorried]: AnswerScoreMap
};

const totalRiskLevel = 6;

const ranges = {
    no_concern: {
        key: "no_concern",
        label: "ranges.no_concern",
        range: "0-2"
    },
    possible: {
        key: "possible",
        label: "ranges.possible",
        range: "3-6"
    }
};

const SisuGuidelineDefinition = [
    {
        min: 3,
        max: 6,
        key: "possible",
        label: "ranges.possible",
        rangeInfo: "3-6",
        ranges,
        riskLevel: 2 / (totalRiskLevel + 1)
    },
    {
        min: 0,
        max: 2,
        key: "no_concern",
        label: "ranges.no_concern",
        rangeInfo: "0-2",
        ranges,
        riskLevel: 1 / (totalRiskLevel + 1)
    }
];

function CalcScore(answers) {
    console.log("Calc Score Answers:  ", answers);
    return Object.keys(answers).reduce((calculatedScore, question) => {
        let score = 0;
        const scoreMap = ScoreMap[question];
        console.log("scoreMap", scoreMap);
        if (scoreMap) {
            const match = scoreMap.find(obj => obj.answer === answers[question]);
            score = match ? match.score : 0;
            console.log("score", score);
        }

        return calculatedScore + score;
    }, 0);
}

/**
 * Finds the guideline for the given score
 * @param score
 * @returns {*}
 */
function SisuGuideline(score) {
    return SisuGuidelineDefinition.find(gl => CoreUtils.isWithin(score, gl.min, gl.max));
}

function StressGad(answers) {
    const score = CalcScore(answers);
    const guideline = SisuGuideline(score);
    const rangeInfo = guideline.rangeInfo;
    const key = guideline.key;
    const ranges = SisuGuidelineDefinition;
    const label = guideline.label;
    return { score, rangeInfo, key, ranges, label };
}

const RiskName = "STRESS_GAD2";
const RiskCode = "STRESS_GAD2";
const GuidelineName = "SiSU STRESS_GAD2 Guideline";
const GuidelineCode = "SISU_STRESS_GAD2";

export {
    CalcScore,
    SisuGuideline,
    StressGad,
    SisuGuidelineDefinition,
    RiskName,
    RiskCode,
    GuidelineName,
    GuidelineCode
};
